import { render, staticRenderFns } from "./PendingCustomerDetail.vue?vue&type=template&id=187f5410"
import script from "./PendingCustomerDetail.vue?vue&type=script&lang=js"
export * from "./PendingCustomerDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports